'use strict';
import currentLayout from '../detect-layout';
import analytics from '../analytics';
import customModal from '../modal';
import util from '../util';
import productTile from '../product-tile';
import reassurance from '../pages/product/reassurance';
import reinsuranceCheckout from './reinsuranceCheckout';

/**
 * @private
 * @function
 * @description document load handler.
 */
function initLoadHandler() {
    var checkLayout = currentLayout.init();
	
	/*Disabling below code to avoid closing of other accordion tabs and scroll behaviour
		// initialize ui-accordion
		accordionInit(".pdp-accordion", ".pdp-accordion__header");
   		// trigger an event when panel is toggled
     	accordionActivated(".pdp-accordion");
	*/
	// add flag to sticky-buy-container
	makeProductSetStickyCTA();	
}

/**
 * @private
 * @function
 * @description to handle DOM events.
 */
function initEventsHandlers() {
	// to detect layout on Resize
	var checkLayout = currentLayout.init();
	
	// jump to OOS primary CTA section
	$('.pdp-sticky-cta-wrapper').on('click', '.add-to-cart-out-of-stock .button-oos', function () {		
		var $ctaWrapper = $('.product-details-wrapper .add-to-cart-wrapper .price-size-wrapper');
		if($ctaWrapper.length) {
			$('html, body').animate({  
				scrollTop: ($ctaWrapper.offset().top - $ctaWrapper.outerHeight(true))
			}, 600);
		}
	});

	readMoreProductDesc();
}

/**
 * @private
 * @function
 * @description screen resize handler.
 */
function initResizeHandler() {
	// store the window width
	var windowWidth = $(window).width();

	$(window).on('resize orientationchange', function () {
       
		// check window width has actually changed and it's not just iOS triggering a resize event on scroll
		if ($(window).width() != windowWidth) {
			
			/*Disable accordion 
			if(checkLayout != 'mobile') {
				// enable accordion in mobile & desktop
				accordionInit(".pdp-accordion", ".pdp-accordion__header");
				disableJumpNavInMobile();
			*/

			// to hide on resize event
			toggleVariationsSticky();
			regimeSscrollTracker();
			reinsuranceCheckout.reinsurancePanelWidth();
		}
	});
}

// jquery UI Accordion.
// parameter accepts dom selector i.e. ".element" or "#element"
function accordionInit(element, headerElement) {
	var options = {
		header: headerElement,
		collapsible: true,
		active: false,
		heightStyle: "content"
	};
	$(element).accordion(options);
}

function accordionDestroy(element) {
	if($(element).accordion("instance")) {
		$(element).accordion("destroy");
	}	
}

function accordionActivated(element) {
    // to check accordion instance exist
    if($(element).accordion("instance")) {
        // returns ui-accordion active panel status
        $(element).on("accordionactivate", function( event, ui ) {
            var slickSlider = $(this).find('.slick-slider');
            if(slickSlider.length) {
                // to set slick slider dimention on accordion toggle event 
                $('.slick-slider').slick('setPosition');
            }	
        });
    }
}

// sticky jump-links event initialization
function stickyJumpLinksInit() {
	var $link = $('.pdp-jump-links .link-wrapper a'),
		$section = $('.scrollspy');

	$(window).on('scroll', function () {
		if($link.length && $section.length) {
			scrNav();	
			/*Disable accordion
				toggleStickyNav();
				disableJumpNavInMobile();
			*/
		}	
	});

	// jump to the respective section
	$('.pdp-jump-links .link-wrapper a').on('click', function (e) {
		e.preventDefault();
		var self= $(this)
		if (self.hasClass("nav-active")) {  
			return;
		}

		var target = $(self.attr('href')),
		scrollTopOffset = (function (){ 
			var topOffset = target.offset().top;
			if (!$(".pdp-jump-links").hasClass("sticky")) { 
				topOffset -= $(".pdp-jump-links").outerHeight(true); 
			}
			if (self.parent().is(":first-child")){
				topOffset += 10;    
			} 
			return topOffset;     
		})();
		$('html, body').animate({  
			scrollTop: scrollTopOffset
		}, 600);
	});

	// jump to the breadcrumb section
	$(".pdp-jump-links .sticky-buy-link").on('click', function(e) {
		e.stopPropagation();
		var $main = $("#main");
		if($main.length) {
			$('html, body').animate({
				scrollTop: $main.offset().top === 0 ? ($main.offset().top + 80) : $main.offset().top
			}, 600);
		}		
	});
}

// GMW sticky jump link
function scrNav(scroll) {
    var link = $('.pdp-jump-links .link-wrapper a'),
		section = $('.scrollspy'), // selector to jump when id detected
        stop = $(window).scrollTop(),
        isNavLinkactived = false; // flag to check if in zone;

		if( link.length && section.length ) {
			section.each(function () {
				var id = $(this).attr('id'),		
					position = $(this).offset().top - 1,
					height = $(this).height();
				if (stop >= position && stop < position + height) {
					link.removeClass('nav-active');
					$('.pdp-jump-links .link-wrapper a[href*="' + id + '"]').addClass('nav-active');
					isNavLinkactived = true;
				} 
			});
		}
}

// to toggle sticky jump nav
function toggleStickyNav() {
	var $scrollZone = $('.pdp-accordion-wrapper'),
		$jumpLinkNav = $('.pdp-jump-links');

	if($scrollZone.length && $jumpLinkNav.length) {
		if($(window).scrollTop() >= ($scrollZone.offset().top + $scrollZone.outerHeight(true) + 1)) {
			$jumpLinkNav.hide();
		} else {
			$jumpLinkNav.show();
		}
	}
}

// disable jump nav in mobile
function disableJumpNavInMobile() {	
	var $jumpLinkNav = $('.pdp-jump-links');
	var checkLayout = currentLayout.init();

	if($jumpLinkNav.is(':visible') && checkLayout == 'mobile'){	
		$jumpLinkNav.hide();
	}
}

// to check element is in the viewport
function isOnScreen(elem) {
	// if the element doesn't exist, abort
	if( elem.length == 0 ) {
		return;
	}
	var $window = $(window)
	var viewport_top = $window.scrollTop()
	var viewport_height = $window.height()
	var viewport_bottom = viewport_top + viewport_height
	var $elem = $(elem)
	var top = $elem.offset().top
	var height = $elem.height()
	var bottom = top + height

	return (top >= viewport_top && top < viewport_bottom) ||
	(bottom > viewport_top && bottom <= viewport_bottom) ||
	(height > viewport_height && top <= viewport_top && bottom >= viewport_bottom)
}

function toggleVariationsSticky() {
	const checkLayout = currentLayout.init();
	const $stickBuyContainer = $('.stick-buy-container')
	if( checkLayout == 'mobile' ) {	
		$stickBuyContainer.show();	
	} else {
		$stickBuyContainer.hide();
	}
}

// read-more link jumps to product detail section
function readMoreProductDesc() {	
	const $pdpMain = $('.pdp-main'),
		desc = $pdpMain.find('.pdp-accordion-wrapper'),
		$shortDescPart = $pdpMain.find('.shortDescPart2'),
		$readLess = $pdpMain.find('.pdp-desc-read-less'),
		$readMore = $pdpMain.find('.pdp-desc-read-more'),
		checkLayout = currentLayout.init();

	if(desc.length && $readMore.length) {
		$pdpMain.on('click', '.pdp-desc-read-more, .pdp-desc-read-less', function (e) {
			e.preventDefault();
			
			if(checkLayout == 'mobile'){
				$shortDescPart.toggleClass('is-show');
				$readLess.toggleClass('is-show');
				$readMore.toggleClass('is-hide');
			}
		});
	}
}

function makeProductSetStickyCTA() {
	var $productSet = $('#product-set');
	if($productSet.length) {
		$productSet.closest('.pt_product-details').find('.stick-buy-container').addClass('bundle-sticky-buy-container');
		$("#add-all-to-cart").is(":disabled") ? $('.bundle-sticky-buy-container .add-to-cart-in-stock').addClass('disabled') : $('.bundle-sticky-buy-container .add-to-cart-in-stock').removeClass('disabled');
	}
}

function ominibusTooltip(){
	if($('.ominibus-tooltip').length > 0){
		var ominibusContent = $('.ominibus-tooltip-content');
		$('.ominibus-tooltip #ominibus-show').on('click', function(e){
			e.stopPropagation();
			$(this).closest('.ominibus-tooltip').find(ominibusContent).removeClass('hidden');
		});
		$(ominibusContent).on('click', function(e){
			e.stopPropagation();
		});
		$('.ominibus-tooltip #ominibus-hide').on('click', function(){
			$(this).closest('.ominibus-tooltip').find(ominibusContent).addClass('hidden');
		});
		$('html').on('click', function(){
			!$(ominibusContent).hasClass('.hidden') && $(ominibusContent).addClass('hidden');
		});

		$('html:lang(de)') && $('.ominibus-price-wrapper').closest('.price-size-wrapper').addClass('ominibus-padding');
	}
}

function regimeSscrollTracker() {
	if($('.pdp-page').length > 0 && $('.regimenzone-redesign-mobile').length > 0) {
		if($(window).width() < 991){
			// OverlayScrollbars initialization with an element
			const osInstance = OverlayScrollbars(document.querySelector('.regimenzone-redesign-mobile .regimen-carousel'), {});
			
			$('.pdp-page').addClass('re-regimen-active');
			setTimeout(() => {
				util.equalHeight($('.regimenzone-redesign-mobile .product-tile-wrapper'));
			}, 500);
			
			var elementSelector = $('.regimenzone-redesign-mobile .product-tile-wrapper');
			elementSelector.each(function (index, ele) {
			$(ele).find('.attribute .basic-price').length > 0 && $(ele).find('.product-variants-wrapper').addClass('shift-up');
		});
		} else {
			const osInstance = OverlayScrollbars(document.querySelector('.regimenzone-redesign-mobile .regimen-carousel'), {}).destroy();
			$('.regimenzone-redesign-mobile .product-tile-wrapper').removeAttr('style');
		}
	}
  }

// EER-6885 Multiple promotion message display
function promotionMessageSlider() {
	$('.promo-slider-thumbnail').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		fade: true,
		asNavFor: '.promo-slider-nav'
	});

	$('.promo-slider-nav').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		asNavFor: '.promo-slider-thumbnail',
		dots: false,
		infinite: true,
		centerMode: false,
		arrows: true,
	});
}

// Keep only one section open within each PDP accordion.
function pdpAccordionEventsHandler() {
	$('.pdp-accordion__header').off('click.pdpAccordion').on('click.pdpAccordion', function (e) {
		e.preventDefault();
		const $header = $(this);
		const $otherHeaders = $header.closest('.pdp-accordion').find('.pdp-accordion__header').not($header);

		$otherHeaders.removeClass('ui-accordion-header-active').next('.pdp-accordion__content').hide();
		$header.next('.pdp-accordion__content').toggle();
		$header.toggleClass('ui-accordion-header-active');
	});
}

export default {
	
    init: function() {
        initLoadHandler();
        initEventsHandlers();
        initResizeHandler();
		$(window).on('scroll', util.debounce(toggleVariationsSticky(), 200));
		ominibusTooltip();
		regimeSscrollTracker();
		pdpAccordionEventsHandler();
		reinsuranceCheckout.reinsurancePanelHandlerPdp();
		productTile.init();
		util.setCompareAttributesEqualHeight('.product-compare-attributes', '.compare-attributes-item');
		reassurance.init();
		if($(".oos_inline-item").length>0 && $(".oos_inline-item").html().trim().length == 0 && (!$('.free_text-zone').length || !$('.shipping-vat-info').length)) {
			$('.oos_inline-item').parents('.inline-links-wrapper').hide();
		}
    }
};